// Function to check if the variants are in the cart
function checkVariantsInCart(callback) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      // Initialize variables to track variants in the cart
      var is44000071516333InCart = false;
      var is42272520994989InCart = false;
      var is43784201961645InCart = false;

      // Check if the variants are in the cart
      cart.items.forEach(function(item) {
        if (item.variant_id === 44000071516333) is44000071516333InCart = true;
        if (item.variant_id === 42272520994989) is42272520994989InCart = true;
        if (item.variant_id === 43784201961645) is43784201961645InCart = true;
      });

      // Call the callback with the status of each variant
      callback(is44000071516333InCart, is42272520994989InCart, is43784201961645InCart, cart);
    }
  });
}

// Function to remove variants from the cart
function removeVariantsFromCart(variantIds) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      cart.items.forEach(function(item) {
        if (variantIds.includes(item.variant_id)) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              id: item.id, // Line item ID to remove
              quantity: 0     // Setting quantity to 0 removes the item
            },
            dataType: 'json',
            success: function(response) {
               
            },
            error: function(error) {
              console.error('Error removing variant from cart:', error);
            }
          });
        }
      });
    }
  });
}

// Function to add a variant to the cart
function addVariantToCart(data) {

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(response) {

       console.log('this hit response', response)

    },
    error: function(error) {
      console.error('Error adding variant ');
    }
  });
}

// Function to add the free gift based on the total price
function addFreeGift() {
  var totalRegularPrice = 0;

  // Loop through each element with the class 'price__regular' to sum up the prices
  $('cart-items .price__regular').each(function() {
    var priceText = $(this).text().replace(/[^0-9.-]+/g, "");
    var quantity = $(this).closest('li').find('.quantity__input').val() ? $(this).closest('li').find('.quantity__input').val()  : 0;
    console.log('quantity', $(this).closest('li').find('.quantity__input').val())
    totalRegularPrice += parseFloat(priceText) * quantity;
  });



  // Check if the totalRegularPrice is >= 200
  checkVariantsInCart(function(is44000071516333InCart, is42272520994989InCart, is43784201961645InCart, cart) {
     if (totalRegularPrice >= 200) {
         if (!is42272520994989InCart)
          addVariantToCart({
          id: 42272520994989,
          quantity: 1,
          properties: { freeGift: true }  // Add the properties here
          });
        if (!is43784201961645InCart)
            addVariantToCart({
          id: 43784201961645,
          quantity: 1,
          properties: { freeGift: true } // Add the properties here
        });
    } 
    else if (totalRegularPrice >= 150 && !is44000071516333InCart) {
      if (is43784201961645InCart) {
        removeVariantsFromCart([43784201961645]); // Remove variant 43784201961645 if already in the cart
      }
 
        let data = {
          id: 42272520994989,
          quantity: 1,
          properties: { freeGift: true } // Add the properties here
        }
      if (!is42272520994989InCart)
      addVariantToCart(data); // Add variant 42272520994989 with freeGift property
    } 
 
    else if (totalRegularPrice >= 100 && totalRegularPrice < 150 ) {
      if (is44000071516333InCart || is42272520994989InCart) {
        removeVariantsFromCart([44000071516333, 42272520994989]); // Remove conflicting variants
      }
        let data = {
          id: 43784201961645,
          quantity: 1,
          properties: { freeGift: true } // Add the properties here
        }
      if (!is43784201961645InCart)
      addVariantToCart(data); // Add variant 43784201961645 with freeGift property
    } 
    // If totalRegularPrice is < 100, remove all relevant variants
    else {
      removeVariantsFromCart([44000071516333, 42272520994989, 43784201961645]); // Remove all variants
    }
  });
}

// Call the function to add the free gift

setTimeout(function() {
// addFreeGift();
  rotateMessages(); 

  }, 500); 



// Placeholder function to calculate the savings amount
function calculateSavings() {
 // Initialize a variable to store the total price
let regularTotalPrice = 0;
let saleTotalPrice = 0;



// Select all product elements (li elements that represent each product)
const products = document.querySelectorAll('li.horizontal-product');

// Loop through each product
products.forEach(product => {
  // Select the sale price element within the product

                let priceElement = product.querySelector('.price__regular');
   priceSaleElement = product.querySelector('.price__sale');

  if(priceElement && priceSaleElement) {
      regularPrice = parseFloat(priceElement.textContent.replace(/[^0-9.-]+/g,""));

    // Select the quantity input field within the same product
    const quantityInput = product.querySelector('.quantity__input');
    
    // Extract the quantity value and convert it to a number

    const quantity = quantityInput ? parseInt(quantityInput.value) : 0;
    
    // Multiply the sale price by the quantity and add to the total

    regularTotalPrice += regularPrice * quantity;

}


  // If a sale price exists
  if(priceElement && priceSaleElement) {
    // Extract the price, remove any non-numeric characters (like $), and convert to a number
     salePrice = parseFloat(priceSaleElement.textContent.replace(/[^0-9.-]+/g,""));

    // Select the quantity input field within the same product
    const quantityInput = product.querySelector('.quantity__input');
    
    // Extract the quantity value and convert it to a number
    const quantity = quantityInput ? parseInt(quantityInput.value) : 0;
    
    // Multiply the sale price by the quantity and add to the total

    saleTotalPrice +=  salePrice * quantity;
  }

});

// Output the total sale price to the console or display it somewhere on the page



// Output the total sale price to the console or display it somewhere on the page
return saleTotalPrice -  regularTotalPrice ;
  
}

var messages = [
    '<span style="color: black">You’re saving $<strong>{amount}</strong></span> and Earning {points} points.',
];

var messageIndex = 0;
const randomNumber = 0;

function rotateMessages() {
      setTimeout(function() {

        if(document.querySelector('#CartDrawer .drawer__footer')) {
            const height = window.innerHeight - document.querySelector('#CartDrawer .drawer__footer').offsetHeight - document.querySelector('#CartDrawer .drawer__header').offsetHeight;
            document.querySelector('.cart-container-mini').style.height = `${height}px`;
            document.querySelector('.cart-container-mini').style.overflowY = 'scroll';
          }
        }, 800);
    var savingsAmount = calculateSavings().toFixed(2);
      let totalPoints = 0;

    $(".price").each(function () {
        let points = $(this).attr("reward-points"); // Get the attribute value
        if (points) {
            totalPoints += parseInt(points, 10); // Convert to integer and add to total
        }
    });
  if(savingsAmount > 0) {
    var message = messages[randomNumber].replace('{amount}', savingsAmount).replace('{points}', totalPoints);
  if(document.getElementById('savings-message')) {
     document.getElementById('savings-message').innerHTML = message;
    messageIndex = randomNumber % messages.length;
  }
  } else {
      message = `You are earning ${totalPoints} points.`;
        if(document.getElementById('savings-message')) {
         document.getElementById('savings-message').innerHTML = message;
        }
  }

  const priceElements = document.querySelectorAll('.drawer__content .price--on-sale');

priceElements.forEach(priceElement => {
  // Get the regular price and sale price
  const regularPriceElement = priceElement.querySelector('cart-items .price__regular');
  const salePriceElement = priceElement.querySelector('cart-items .price__sale');

  // Ensure both prices exist 
  if (regularPriceElement && salePriceElement) {
    const regularPrice = parseFloat(regularPriceElement.textContent.replace('$', '').trim());
    const salePrice = parseFloat(salePriceElement.textContent.replace('$', '').trim());
     const discountPercentage = ((salePrice - regularPrice) / salePrice) * 100;
   
    // Check if the discount is more than 40%
    if (regularPrice > 0 && salePrice > 0 && discountPercentage >= 40) {

      // Create the <p> element for Final Sale
      const finalSaleMessage = document.createElement('span');
    finalSaleMessage.classList.add('badge', 'badge--onsale', 'flex', 'items-center', 'gap-1d5', 'leading-none', 'font-medium', 'rounded-full');
      finalSaleMessage.textContent = 'FINAL SALE';

      // Append the <p> element below the price
      priceElement.parentElement.appendChild(finalSaleMessage);
    }
  }

});
    setTimeout(function() {
      if(document.querySelector('#CartDrawer .drawer__footer')) {
            const height = window.innerHeight - document.querySelector('#CartDrawer .drawer__footer').offsetHeight - document.querySelector('#CartDrawer .drawer__header').offsetHeight;

            document.querySelector('.cart-container-mini').style.height = `${height}px`;
            document.querySelector('.cart-container-mini').style.overflowY = 'scroll';
      }
        }, 800);
}
// Start rotating messages every 5 seconds
// Initial call

class TabList extends HTMLUListElement {
  constructor() {
    super();

    this.controls.forEach((button) => button.addEventListener('click', this.handleButtonClick.bind(this)));
  }

  get controls() {
    return this._controls = this._controls || Array.from(this.querySelectorAll('[aria-controls]'));
  }

  handleButtonClick(event) {
    event.preventDefault();

    this.controls.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');

      const panel = document.getElementById(button.getAttribute('aria-controls'));
      panel?.removeAttribute('open');
    });

    const target = event.currentTarget;
    target.setAttribute('aria-expanded', 'true');

    const panel = document.getElementById(target.getAttribute('aria-controls'));
    panel?.setAttribute('open', '');
  }

  reset() {
    const firstControl = this.controls[0];
    firstControl.dispatchEvent(new Event('click'));
  }
}
customElements.define('tab-list', TabList, { extends: 'ul' });

class CartDrawer extends DrawerElement {
  constructor() {
    super();
  }

  get shouldAppendToBody() {
    return false;
  }

  get recentlyViewed() {
    return this.querySelector('recently-viewed');
  }

  get tabList() {
    return this.querySelector('[is="tab-list"]');
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('cart:bundled-sections', this.onPrepareBundledSections.bind(this));
    if (this.recentlyViewed) {
      this.recentlyViewed.addEventListener('is-empty', this.onRecentlyViewedEmpty.bind(this));
    }
  }

  onPrepareBundledSections(event) {
    event.detail.sections.push(theme.utils.sectionId(this));
  }

  onRecentlyViewedEmpty() {
    this.recentlyViewed.innerHTML = `
    <div class="drawer__scrollable relative flex justify-center items-start grow shrink text-center">
      <div class="drawer__empty grid gap-5 md:gap-8">
        <h2 class="drawer__empty-text font-bold leading-none tracking-tight">${theme.strings.recentlyViewedEmpty}</h2>
      </div>
    </div>
    `;
  }

  show(focusElement = null, animate = true) {

    super.show(focusElement, animate);

    if (this.tabList) {
      this.tabList.reset();

      if (this.open) {
        theme.a11y.trapFocus(this, this.focusElement);
      }
    }
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartQuantity extends QuantitySelector {
  constructor() {
    super();
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    super.connectedCallback();
    this.quantityUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('[name="minus"]');
      if (buttonMinus) {
        buttonMinus.disabled = parseInt(value) <= parseInt(this.input.min);
      }
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('[name="plus"]');
      if (buttonPlus) {
        buttonPlus.disabled = parseInt(value) >= parseInt(this.input.max);
      }
    }
  }
}
customElements.define('cart-quantity', CartQuantity);

class CartRemoveButton extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton, { extends: 'a' });

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', theme.utils.debounce(this.onChange.bind(this), 300));
    this.cartUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    console.log('thsif dsfsjf')
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target);
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const cartDrawer = document.getElementById('CartDrawer');
   const element = document.querySelector('[id*="MainCart"]');
const sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : element.id.replace('MainCart-', "");
    const sectionToRender = new DOMParser().parseFromString(event.cart.sections[sectionId], 'text/html');
    const miniCart = document.querySelector(`#MiniCart-${sectionId}`);
    if (miniCart) {
      const updatedElement = sectionToRender.querySelector(`#MiniCart-${sectionId}`);
      if (updatedElement) {
        miniCart.innerHTML = updatedElement.innerHTML;
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(`#MainCart-${sectionId}`);
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      }
      else {
        mainCart.closest('.cart').classList.add('is-empty');
        mainCart.remove();
      }
    }

    const lineItem = document.getElementById(`CartItem-${event.line}`) || document.getElementById(`CartDrawer-Item-${event.line}`);
    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      theme.a11y.trapFocus(mainCart || miniCart, lineItem.querySelector(`[name="${event.name}"]`));
    }
    else if (event.cart.item_count === 0) {
      miniCart
        ? theme.a11y.trapFocus(miniCart, miniCart.querySelector('a'))
        : theme.a11y.trapFocus(document.querySelector('.empty-state'), document.querySelector('.empty-state__link'));
    }
    else {
      miniCart
        ? theme.a11y.trapFocus(miniCart, miniCart.querySelector('.horizontal-product__title'))
        : theme.a11y.trapFocus(mainCart, mainCart.querySelector('.cart__item-title'));
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: event.cart
      }
    }));

      
      rotateMessages();

    if(!$('#customerTag').val().includes('distributor')) {
setTimeout(function() {
// addFreeGift();
  }, 500); 
}
  }


  onCartError(errors, target) {
    if (target) {
      this.updateQuantity(target.dataset.index, target.defaultValue, document.activeElement.getAttribute('name'), target);
    }
    else {
      window.location.href = theme.routes.cart_url;
    }

    alert(errors);
  }

  updateQuantity(line, quantity, name, target) {

    this.enableLoading(line);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle
    });

    fetch(`${theme.routes.cart_change_url}`, { ...theme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState, target, line, name });
        
      })
      .catch((error) => {
        console.log(error);
      });
  }

  enableLoading(line) {
    const sectionId = theme.utils.sectionId(this);
    const loader = document.getElementById(`Loader-${sectionId}-${line}`);
    if (loader) loader.hidden = false;
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', theme.utils.debounce(this.onChange.bind(this), 300));
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${theme.routes.cart_update_url}`, { ...theme.utils.fetchConfig(), ...{ body } });
  }
}
customElements.define('cart-note', CartNote);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart:bundled-sections', this.onPrepareBundledSections.bind(this));
  }

  onPrepareBundledSections(event) {
    event.detail.sections.push(theme.utils.sectionId(this));
  }
}
customElements.define('main-cart', MainCart);

class CountryProvince extends HTMLElement {
  constructor() {
    super();

    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));

    if (this.getAttribute('country') !== '') {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.dataset.country));
      this.countryElement.dispatchEvent(new Event('change'));
    }
    else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.dataset.provinces);
    this.provinceElement.parentElement.hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = '';

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
    });
  }
}
customElements.define('country-province', CountryProvince);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.setAttribute('aria-busy', 'true');

    const body = JSON.stringify({
      shipping_address: { zip, country, province }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...theme.utils.fetchConfig('javascript'), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        }
        else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.removeAttribute('aria-busy');
      });

  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error grid gap-2 text-sm leading-tight">
        <p>${theme.shippingCalculatorStrings.error}</p>
        <ul class="list-disc grid gap-2" role="list">${shippingRatesList.join('')}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(({ presentment_name, currency, price }) => {
      return `<li>${presentment_name}: ${currency} ${price}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--${shippingRates.length === 0 ? 'error' : 'success'} grid gap-2 text-sm leading-tight">
        <p>${shippingRates.length === 0 ? theme.shippingCalculatorStrings.notFound : shippingRates.length === 1 ? theme.shippingCalculatorStrings.oneResult : theme.shippingCalculatorStrings.multipleResults}</p>
        ${shippingRatesList === '' ? '' : `<ul class="list-disc grid gap-2" role="list">${shippingRatesList.join('')}</ul>`}
      </div>
    `;

  }
}
customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });



